import { useEffect, useState } from 'react';

import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

import { every, trim } from 'lodash';

import { DispatchScheduleDoc } from '@isd/lib/firebase/db/metaTypes';

import { useSchedulerContext } from '@/context/SchedulerContext';

import { DispatchScheduleFormContextData } from '@/components/DispatchSchedule/DispatchScheduleForm';

export default function ScheduleNameInput({
  dispatchScheduleDoc,
}: {
  dispatchScheduleDoc?: DispatchScheduleDoc | null;
}) {
  const { dispatchSchedulesOptions } = useSchedulerContext();
  const { register, formState } =
    useFormContext<DispatchScheduleFormContextData>();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(formState.isDirty && !!formState.errors.scheduleName);
  }, [formState]);

  const validateScheduleName = (scheduleName: string) => {
    // Check that schedule name has not changed or is unique among other options
    return (
      scheduleName.toLocaleLowerCase() ===
        dispatchScheduleDoc?.get('name')?.toLocaleLowerCase() ||
      every(dispatchSchedulesOptions, (dispatchScheduleOption) => {
        return (
          dispatchScheduleOption.name.toLocaleLowerCase() !==
          scheduleName.toLocaleLowerCase()
        );
      }) ||
      `Schedule named "${scheduleName}" already exist`
    );
  };

  return (
    <>
      <div className="text-lg font-bold">
        Schedule Name<span className="text-red-600">*</span>
      </div>
      <input
        {...register('scheduleName', {
          required: true,
          setValueAs: trim,
          validate: validateScheduleName,
          maxLength: 50,
        })}
        type="text"
        placeholder="How would you like to identify this schedule?"
        className={clsx('input w-full', hasError && 'input-error')}
      />
    </>
  );
}
